<form>
    <div class="form_group">
        <input type="text" class="form_control" [ngModelOptions]="{standalone: true}" 
        [(ngModel)]="searchText" placeholder="Search" required>
        <button class="search_btn" type="submit" (click)="redirect(searchText)">
            <i class="fal fa-2x fa-search align-middle"></i></button>
    </div>
</form>